import { Controller } from "@hotwired/stimulus"

// Affiche la modale d'export PDF (o-modal) dès qu'elle est injectée, et la
// retire du DOM à la fermeture (croix / fond / Échap).
export default class extends Controller {
  static values = { userId: Number }

  connect() {
    this.element.classList.add("is-open")
    this.boundEscape = this.escape.bind(this)
    document.addEventListener("keydown", this.boundEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundEscape)
  }

  close(event) {
    if (event) event.preventDefault()
    this.element.remove()
  }

  backdrop(event) {
    if (event.target === this.element) this.close()
  }

  escape(event) {
    if (event.key === "Escape") this.close()
  }
}
